import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import {
 
  fan1,
  fan2,
  fan3,
  fan4,
  fan5,
  fan6,
  fan7,
  fan8,
  fan9,
  fan10,
  fan11,
  fan12,
 


} from "../assets/images/index";

const FansPrice = () => {
  const products = [
 
          {
            _id: "1011",
            img: fan1,
            productName: "Royal Deluxe Ceiling Fan",
            price: "9900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
          },
          {
            _id: "1012",
            img: fan2,
            productName: "Royal Saver Ceiling Fan",
            price: "10200",
            color: "Energy",
            badge: false,
            des: "SKU: Royal Smart Series ESF (White)-0000001Royal Energy Saver Fans are designed on the principle of conserving energy to preserve the planet. To ensure the provision of energy-efficient solutions, Royal Fans takes pride in manufacturing Pakistan's first energy saver fans that use less energy, and are not heavy on the electricity bills."
          },
          {
            _id: "1013",
            img: fan3,
            productName: "Royal Hi-Standard Ceiling Fan",
            price: "8700",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Hi Standard Ceiling Fan-56/COPPER-(Off-White)-0000004Royal Deluxe Series are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
          },
          {
            _id: "1014",
            img: fan4,
            productName: "Royal Passion Ceiling Fan - GRACE",
            price: "9900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Passion Ceiling Fans-56/COOPER-(Off-White Sheesham Wood)-0000004The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
          },
          {
            _id: "1015",
            img: fan5,
            productName: "Royal Petite Bracket Fan",
            price: "6900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Petite Bracket Fan-12/COPPER-(Off-White)-0000002Be it your corridor, terrace, lobby, or veranda, the Royal Petite Fan is the best fit any place where space is limited. With its small wing blades and alluring shades of pearl white and impressive black, this fan is a petite powerhouse."
          },
          {
            _id: "1016",
            img: fan6,
            productName: "Royal Platinum Ceiling Fan",
            price: "9900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(Off-White)-0000003Royal Deluxe Series  are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
          },
          {
            _id: "1017",
            img: fan7,
            productName: "Royal Water Proof Ceiling Fan - Majesty",
            price: "9900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Water Proof Ceiling Fans-56/COPPER-(Off-White)-0000002Our Water Proof Ceiling Fans are designed to work in open areas, mosques, etc. that are exposed to extreme weather conditions as well as to keep them safe from dust and moisture. If you are planning to invest in a fan that has the quality to perform well along with being waterproof, then you have come to the right place.      "
          },
          {
            _id: "1018",
            img: fan8,
            productName: "Royal RL-040- Smart Lifestyle ACDC Fan",
            price: "13200",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Lifestyle-RL-040(Off-White Sheesham Wood)-0000001Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
          },
          {
            _id: "1019",
            img: fan9,
            productName: "Royal RL-050 - Smart Lifestyle ACDC Fan",
            price: "13200",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Lifestyle-RL-050(Off White Pinewood)-0000003Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
          },
          {
            _id: "1020",
            img: fan10,
            productName: "Royal Smart Prime ACDC Ceiling Fan - Prime",
            price: "10200",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Smart Prime Ceiling Fans(Off-White)-0000003fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth"
          },
          {
            _id: "1021",
            img: fan11,
            productName: "Ornament - Smart Lifestyle ACDC Fan",
            price: "18600",
            color: "Ornament",
            badge: false,
            des: "SKU: Ornament 001Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
          },
          {
            _id: "1022",
            img: fan12,
            productName: "Royal Passion Grace - Prime ACDC Ceiling Fan",
            price: "10200",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Smart Passion ACDC Grace 00004Our Smart AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth"
          },
          {
            _id: "1011",
            img: fan1,
            productName: "Royal Deluxe Ceiling Fan",
            price: "9900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
          },
          {
            _id: "1012",
            img: fan2,
            productName: "Royal Energy Saver Ceiling Fan",
            price: "10200",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Smart Series ESF (White)-0000001Royal Energy Saver Fans are designed on the principle of conserving energy to preserve the planet. To ensure the provision of energy-efficient solutions, Royal Fans takes pride in manufacturing Pakistan's first energy saver fans that use less energy, and are not heavy on the electricity bills."
          },
          {
            _id: "1013",
            img: fan3,
            productName: "Royal Hi-Standard Ceiling Fan",
            price: "8700",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Hi Standard Ceiling Fan-56/COPPER-(Off-White)-0000004Royal Deluxe Series are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
          },
          {
            _id: "1014",
            img: fan4,
            productName: "Royal Passion Ceiling Fan - GRACE",
            price: "9900",
            color: "Royal",
            badge: false,
            des: "SKU: Royal Deluxe Passion Ceiling Fans-56/COOPER-(Off-White Sheesham Wood)-0000004The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
          },

    
  ];

  const downloadPDF = () => {
    const input = document.getElementById("price-list"); 
    const pdf = new jsPDF("p", "mm", "a4");
    const pageHeight = pdf.internal.pageSize.height; 
    const pageWidth = pdf.internal.pageSize.width;
  
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width; 
  
      let yPosition = 0;
  
      while (yPosition < imgHeight) {
        pdf.addImage(imgData, "PNG", 0, -yPosition, imgWidth, imgHeight);
        yPosition += pageHeight; 
  
        if (yPosition < imgHeight) {
          pdf.addPage(); 
        }
      }
  
      pdf.save("price-list.pdf");
    });
  };
  return (
    <div className="max-w-container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-5">Fans Price List</h1>
      <button
        onClick={downloadPDF}
        className="bg-dark text-white px-4 py-2 mb-5 rounded"
      >
        Download PDF
      </button>
      <div id="price-list" className="space-y-6">
        {products.map((product) => (
          <div
            key={product._id}
            className="flex items-start border rounded shadow p-5"
          >
            <img
              src={product.img}
              alt={product.productName}
              className="w-36 h-36 object-contain mr-5"
            />
            <div>
              <h2 className="text-xl font-semibold">{product.productName}</h2>
              <p className="text-gray-600 mt-2">{product.des}</p>
              <span className="text-lg font-bold mt-2 block">
                Rs.{product.price}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FansPrice;
